const getCurrentCart = (state) => state.currentCart;

export default {
  getCurrentCart,
};
